import { Component, Input } from '@angular/core';
import { EoBaseViewComponent } from '../eo-base-view/eo-base-view.component';
import { IViewComponent } from '../eo-base-view/i-view-component';
import { EoViewComponentTypeEnum } from '../eo-base-view/eo-view-component-type-enum';

@Component({
  selector: 'eo-label',
  templateUrl: './eo-label.component.html',
  styleUrl: './eo-label.component.scss',
})
export class EoLabelComponent
  extends EoBaseViewComponent
  implements IViewComponent
{
  @Input() toolTipPosition: string = 'right';
  @Input() icon: string = '';
  @Input() severity: string = 'info';

  getFormattedValue(): string {
    return this.value?.toString() ?? '-';
  }

  getViewComponentType(): EoViewComponentTypeEnum{
    return EoViewComponentTypeEnum.LABEL;
  }
}
